// All the installation codes
import './bootstrap';

// A general Store that holds all the global data (no, we're not using Vuex, because we're not sold on it!)
import './store';

// Vue instance
import './vue-codes';



// WEBPACK FOOTER //
// ./resources/assets/js/app.js